module.exports = __webpack_public_path__ + "static/media/sack-dollar.f07a9a4d.svg";